<div class="solid-fallback-background"></div>
<div class="prelogin-background"></div>
<div class="container">
  <div class="prelogin-logo-container">
    <img class="prelogin-logo" src="../../../../assets/hubtiger_logo_full.png" (click)="home()">
  </div>

  <div>
    <div class="hub-content">
      <div class="wizard-register-containers prelogin-container">

        <div class="wizard-free-trial">
          <div class="trial-title">TWO-FACTOR AUTHENTICATION.</div>
          <div class="trial-blurb">Please enter the two-factor authentication code from your authenticator.</div>
        </div>

        <div class="wizard-inner-container">

          <div class="row">
            <div class="col-md-12">

              <form [formGroup]="tfaForm" (ngSubmit)="signInWithCode(tfaForm.value)">
                <div class="">
                  <label for="code" class="col-form-label">
                    Enter here the code provided by the Google Authenticator app:
                  </label>
                  <input type="text" id="code" formControlName="code" class="form-control"/>
                  <em *ngIf="validateControl('code') && hasError('code', 'required')">
                    Code is required
                  </em>
                </div>
                <button type="submit" class="btn btn-primary" [disabled]="!tfaForm.valid || isBusy" [hidden]="isBusy">
                  Sign in
                </button>
                <div *ngIf="isBusy" class="spinner-container">
                  <div class="spinner-border" role="status"></div>
                </div>

                <div *ngIf="showError" class="alert alert-danger" role="alert" style="margin-top:16px;">
                  {{errorMessage}}
                </div>
              </form>
            </div>
          </div>

          <!-- <div class="row">
            <div class="col-md-12">
              <button type="button" class="btn btn-primary" (click)="register2FA()" [disabled]="false">Don't have it? Register here.</button>
            </div>
          </div> -->

        </div>
      </div>
    </div>
  </div>

  <p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
</div>
<!--<app-help-request></app-help-request>-->
